<mat-toolbar class="toolbar">
  @for (item of items; track item.section) {
    @if (item.enabled) {
      <button
        mat-button
        class="button"
        [routerLink]="['/l', 'current', item.section]"
        [class.is-active]="activeSection() === item.section"
      >
        <div class="icon-wrapper">
          <mat-icon matPrefix fontSet="material-symbols-rounded">{{ item.icon }}</mat-icon>
        </div>
        <span>{{ item.labelKey | translate }}</span>
      </button>
    } @else {
      <span class="nav-btn-wrapper">
        <button
          mat-button
          class="button"
          aria-disabled="true"
          [matTooltip]="'comingSoonTooltip' | translate"
          matTooltipPosition="above"
          #tooltip="matTooltip"
          (click)="tooltip.show()"
        >
          <div class="icon-wrapper">
            <mat-icon matPrefix fontSet="material-symbols-rounded">{{ item.icon }}</mat-icon>
            <span class="soon-badge"></span>
          </div>
          <span>{{ item.labelKey | translate }}</span>
        </button>
      </span>
    }
  }
  @if (currentLocation(); as location) {
    <button
      mat-button
      class="button"
      [class.is-active]="isDataPage()"
      (click)="openLocationPicker($event)"
    >
      <div class="icon-wrapper">
        @if (showLogo()) {
          <img
            matListItemIcon
            class="location-logo"
            [src]="currentLocation()!.logo!.url"
            width="20"
            alt=""
            (error)="onLogoError()"
          />
        } @else {
          <mat-icon matListItemIcon fontSet="material-symbols-rounded">storefront</mat-icon>
        }
      </div>
      <span class="location-name">{{ location.name }}</span>
    </button>
  }
</mat-toolbar>
